import { useQuery } from '@tanstack/react-query';
import { getPublicSiteSettings } from '../services/siteSettingsApi.js';

export default function usePublicSettings() {
  const query = useQuery({
    queryKey: ['public', 'site-settings'],
    queryFn: () => getPublicSiteSettings().then((r) => r.data),
    staleTime: 1000 * 60 * 5, // 5 min — settings change rarely; refresh reloads it
  });
  return { settings: query.data || {}, ...query };
}
